var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.688,
    height: 63.392,
    viewBox: "0 0 64.688 63.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_01",
    transform: "translate(-16.75 -17.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27247",
    "data-name": "Path 27247",
    d: "M52.38,77.6H22.355A3.734,3.734,0,0,1,18.4,74.146v-31.4a3.734,3.734,0,0,1,3.953-3.457H42.112V37.714H22.355a5.347,5.347,0,0,0-5.6,5.031v31.4a5.347,5.347,0,0,0,5.6,5.031H52.583A8.228,8.228,0,0,0,52.38,77.6Z",
    transform: "translate(0 -9.37)",
    fill: "#002b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27248",
    "data-name": "Path 27248",
    d: "M110.157,37.714H89.2v1.575h20.956a3.778,3.778,0,0,1,4.025,3.457v31.4a3.777,3.777,0,0,1-4.025,3.457h-1.992v1.575h1.992c3.146,0,5.706-2.257,5.706-5.031v-31.4C115.863,39.971,113.3,37.714,110.157,37.714Z",
    transform: "translate(-34.425 -9.37)",
    fill: "#002b3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27249",
    "data-name": "Path 27249",
    d: "M99.975,61.043H71.24a.84.84,0,1,1,0-1.68H99.975a.84.84,0,0,1,0,1.68Z",
    transform: "translate(-25.492 -19.656)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27250",
    "data-name": "Path 27250",
    d: "M99.975,74.043H71.24a.84.84,0,1,1,0-1.68H99.975a.84.84,0,1,1,0,1.68Z",
    transform: "translate(-25.492 -25.833)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27251",
    "data-name": "Path 27251",
    d: "M83.084,85.223a1.285,1.285,0,0,1,.339-.609H72.24a.84.84,0,0,0,0,1.68H82.788A1.426,1.426,0,0,1,83.084,85.223Z",
    transform: "translate(-25.967 -31.654)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27252",
    "data-name": "Path 27252",
    d: "M121.713,84.614H116.15a1.337,1.337,0,0,1,.733,1.679h4.83a.839.839,0,1,0,0-1.679Z",
    transform: "translate(-47.23 -31.654)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27253",
    "data-name": "Path 27253",
    d: "M106.443,91.237h-1.575V84.219c-.789-4.488-5.43-5.11-6.137-5.179-6.551,1.087-6.256,6.657-6.24,6.894l0,.055v5.248H90.919V86c-.025-.6-.119-7.307,7.66-8.535l.087-.014.088.006c2.3.15,6.872,1.715,7.68,6.561l.011.13v7.085Z",
    transform: "translate(-35.24 -28.253)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27254",
    "data-name": "Path 27254",
    d: "M85.5,121.4c-2.315,0-3.307-2.342-3.508-3.581l-.01-.126V102.214h23.888v15.439a3.511,3.511,0,0,1-.693,2.819,3.012,3.012,0,0,1-2.3.928h0a3.649,3.649,0,0,1-.474-.029H85.984A3.684,3.684,0,0,1,85.5,121.4Zm-1.943-3.778c.075.376.572,2.437,2.252,2.18l.117-.009,16.668.012a2.067,2.067,0,0,0,.283.017,1.535,1.535,0,0,0,1.125-.4,2.209,2.209,0,0,0,.3-1.638l-.005-.09V103.787H83.56Z",
    transform: "translate(-30.997 -40.017)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27255",
    "data-name": "Path 27255",
    d: "M102.6,119.289a3.435,3.435,0,1,1,3.435-3.435A3.44,3.44,0,0,1,102.6,119.289Zm0-5.3a1.861,1.861,0,1,0,1.861,1.861A1.863,1.863,0,0,0,102.6,113.994Z",
    transform: "translate(-39.157 -44.866)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27256",
    "data-name": "Path 27256",
    d: "M104.945,126.557a.841.841,0,0,1-.84-.84v-2.469a.84.84,0,1,1,1.68,0v2.469A.841.841,0,0,1,104.945,126.557Z",
    transform: "translate(-41.507 -49.612)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21872",
    "data-name": "Rectangle 21872",
    width: 1.575,
    height: 2.469,
    transform: "translate(62.651 73.636)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27257",
    "data-name": "Path 27257",
    d: "M36.657,62.376a7.007,7.007,0,1,1,7.007-7.007A7.014,7.014,0,0,1,36.657,62.376Zm0-12.438a5.432,5.432,0,1,0,5.432,5.432A5.438,5.438,0,0,0,36.657,49.938Z",
    transform: "translate(-6.129 -14.429)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27258",
    "data-name": "Path 27258",
    d: "M43.479,83.912H25.789L25.65,83.3a7.97,7.97,0,0,1,1.328-6.2c1.53-1.952,4.116-2.975,7.687-3.041,0,0,.124-.006.323-.006,1.161,0,5.118.2,7.313,2.825,1.331,1.59,1.766,3.739,1.293,6.386ZM27.1,82.338H42.141a5.653,5.653,0,0,0-1.047-4.45c-1.756-2.1-5.117-2.262-6.105-2.262-.159,0-.253,0-.263.005-3.1.056-5.274.873-6.5,2.427A6.165,6.165,0,0,0,27.1,82.338Z",
    transform: "translate(-4.157 -26.636)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27259",
    "data-name": "Path 27259",
    d: "M44.347,100.293H26.241a.84.84,0,1,1,0-1.68H44.347a.84.84,0,1,1,0,1.68Z",
    transform: "translate(-4.111 -38.306)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21873",
    "data-name": "Rectangle 21873",
    width: 18.107,
    height: 1.575,
    transform: "translate(22.13 60.36)",
    fill: "#3dc8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27260",
    "data-name": "Path 27260",
    d: "M78.54,40.8H64.5V39.23H76.965V30.245H78.54Z",
    transform: "translate(-22.689 -5.821)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27261",
    "data-name": "Path 27261",
    d: "M65.825,34.915H64.25V24.024c0-4.769,4.42-6.029,6.757-6.029,2.685.1,4.681.939,5.962,2.492a6.909,6.909,0,0,1,1.446,4.756l-1.564-.185.782.092-.783-.089a5.257,5.257,0,0,0-1.086-3.517,6.239,6.239,0,0,0-4.785-1.906c-.182,0-5.155.072-5.155,4.386V34.915Z",
    transform: "translate(-22.57)",
    fill: "#002c3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27262",
    "data-name": "Path 27262",
    d: "M74.558,31.58A3.543,3.543,0,1,1,78.1,28.038,3.547,3.547,0,0,1,74.558,31.58Zm0-5.511a1.968,1.968,0,1,0,1.968,1.968A1.971,1.971,0,0,0,74.558,26.07Z",
    transform: "translate(-25.784 -3.088)",
    fill: "#002c3e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit3);
export default __webpack_public_path__ + "static/media/Benefit-3.cff41e02e2da93ba94610a0528c29968.svg";
export { ForwardRef as ReactComponent };